let ratio = .1;

if (window.matchMedia("(max-width: 999px)").matches) {
  ratio = .0015;
}
const options = {
  root: null,
  rootMargin: '0px',
  threshold: ratio
}

const handleIntersect = function (entries, observer) {
  entries.forEach(function (entry) {
    if (entry.intersectionRatio > ratio) {
        if(entry.target.classList.contains('hero__image-container')){
            entry.target.classList.add('active')
        }
        entry.target.classList.remove('reveal')
        observer.unobserve(entry.target)
    }
  })
}

export function triggerRevealScroll()
{
    const observer = new IntersectionObserver(handleIntersect, options)
    document.querySelectorAll('.reveal').forEach(function (r) {
      observer.observe(r)
    })

}